module.exports = __webpack_public_path__ + "static/media/chip-placeholder.96bd8893.png";